import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

// Sends the user back where they came from, so a form opened from an instance page or a
// search result returns there rather than to the admin list. React Router tracks the
// entry's position in window.history.state.idx. At 0 there is nothing to pop -- a pasted
// URL, a new tab, a bookmark, a link from an email -- and navigate(-1) would leave the
// app, so fall back to the given route instead. location.key is no use here: the global
// time-range sync replaces the URL on mount, which mints a new key at idx 0.
export const useReturnTo = (fallback: string) => {
    const navigate = useNavigate();

    return useCallback(() => {
        const idx = window.history.state?.idx ?? 0;

        if (idx > 0) {
            navigate(-1);
        } else {
            navigate(fallback);
        }
    }, [navigate, fallback]);
};

export default useReturnTo;
